import { HX_SPRITE, type HxIconId } from './hx-sprite';

// The Home design's icon system: one hidden <svg> holding every <symbol id="hx-i-*"> once
// per page, and `<Ic id="pin"/>` drawing one with the design's `.ic` class (stroke:
// currentColor, 18px — hx.css). The sprite markup is the export's own, transcribed
// verbatim into hx-sprite.ts: static, trusted, no user input.
export function HxSprite() {
  return <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true" focusable="false" dangerouslySetInnerHTML={{ __html: HX_SPRITE }} />;
}

export function Ic({ id, className }: { id: HxIconId; className?: string }) {
  return (
    <svg className={className ? `ic ${className}` : 'ic'} aria-hidden="true" focusable="false">
      <use href={`#hx-i-${id}`} />
    </svg>
  );
}
